
import React, { useState, useEffect, Suspense, lazy, Component } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { baseUrl } from "./baseUrl";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';

// Lazy load components
const ProductSlider = lazy(() => import("./ProductSlider"));

// Error Boundary Component 
class ErrorBoundary extends Component {
  state = { hasError: false, error: null };

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  render() {
    if (this.state.hasError) {
      return <div>Error: {this.state.error?.message || "Something went wrong."}</div>;
    }
    return this.props.children;
  }
}

function Home(props) {
  const [mostPopularBrands, setMostPopularBrands] = useState([]);
  const [mostPopularProducts, setMostPopularProducts] = useState([]);
  const [stocks, setStocks] = useState([]);
  const [twoImages, setTwoImages] = useState({ image1: "", image2: "" });
  const [gallery, setGallery] = useState([]);
  const [featuredProducts, setFeaturedProducts] = useState([]);
  const [slider, setSlider] = useState([]);

  const getFeaturedProducts = async () => {
    try {
      const selectedWorkingStateId = await localStorage.getItem('selectedWorkingStateId') || '29';
      const url = `${baseUrl}Apicontroller/feature_product/${selectedWorkingStateId}`;
      console.log("Fetching featured products from:", url);
      const response = await axios.get(url);
      console.log("Featured products response:", response?.data?.data);
      if (response.data.status === 200) {
        const cleanedData = response.data.data.filter(item => item && item.product_id);
        setFeaturedProducts(cleanedData.slice(0, 10)); // Limit to 10
      }
    } catch (error) {
      console.error("Error in featured products:", error);
    }
  };

  const getMostPopularProducts = async () => {
    try {
      const selectedWorkingStateId = await localStorage.getItem('selectedWorkingStateId') || '29';
      const response = await axios.get(`${baseUrl}Apicontroller/most_popular_products/${selectedWorkingStateId}`);
      console.log("Most popular products:", response.data);
      if (response.data.status === 200) {
        setMostPopularProducts(response.data.data.slice(0, 10)); // Limit to 10
      }
    } catch {
      console.error("Error in most popular products.");
    }
  };

  const getMostPopularBrands = async () => {
    try {
      const response = await axios.get(`${baseUrl}Apicontroller/brands_view`);
      console.log("Most popular brands:", response.data);
      if (response.data.status === 200) {
        setMostPopularBrands(response.data.data.slice(0, 10)); // Limit to 10
      }
    } catch {
      console.error("Error in most popular brands.");
    }
  };

  const getStocks = async () => {
    try {
      const response = await axios.get(`${baseUrl}Apicontroller/stock_get`);
      console.log("Stocks:", response.data);
      if (response.data.status === 200) {
        setStocks(response.data.data.slice(0, 2)); // Limit to 2
      }
    } catch {
      console.error("Error in stocks.");
    }
  };

  const getTwoImages = async () => {
    try {
      const response = await axios.get(`${baseUrl}Apicontroller/get_two_images`);
      console.log("Two images:", response.data);
      if (response.data.status === 200) {
        setTwoImages(response.data.data);
      }
    } catch {
      console.error("Error in two images.");
    }
  };

  const getGallery = async () => {
    try {
      const response = await axios.get(`${baseUrl}Apicontroller/get_gallery`);
      console.log("Gallery:", response.data);
      if (response.data.status === 200) {
        setGallery(response.data.data.slice(0, 6)); // Limit to 6
      }
    } catch {
      console.error("Error in gallery.");
    }
  };

  const getSlider = async () => {
    try {
      const response = await axios.get(`${baseUrl}Apicontroller/get_slider`);
      console.log("Slider data:", response.data);
      if (response.data.status === 200) {
        setSlider(response.data.data);
      }
    } catch {
      console.error("Error in slider.");
    }
  };

  useEffect(() => {
    getSlider();
    getMostPopularBrands();
    getStocks();
    getMostPopularProducts();
    getTwoImages();
    getGallery();
    getFeaturedProducts();
  }, []);

  // Log state for debugging
  console.log("Current state:", {
    slider,
    mostPopularBrands,
    mostPopularProducts,
    stocks,
    twoImages,
    gallery,
    featuredProducts,
  });

  return (
    <ErrorBoundary>
      <div className="mt-5 mobile_view_sider">
        {/* START SLIDER */}
        <div className="slider-outer">
          <Suspense fallback={<div>Loading Slider...</div>}>
            <Carousel
              autoPlay={false}
              interval={3000}
              showThumbs={false}
              infiniteLoop={true}
              emulateTouch
              showStatus={false}
            >
              {slider.map((elem, i) => (
                <div key={i}>
                  <img
                    src={window.innerWidth >= 650 ? elem.image : elem.app_image}
                    alt={`Slide ${i}`}
                    loading="lazy"
                    style={{ maxHeight: "650px", objectFit: "cover" }}
                  />
                </div>
              ))}
            </Carousel>
          </Suspense>
        </div>
        {/* END SLIDER */}
        {/* START TWO IMAGES */}
        <section className="mt-5">
          <div className="container-fluid">
            <div className="row">
              {twoImages.image1 && (
                <div className="col-md-6">
                    <Link to="subcategory/8">
                  <a href="#">
                    <img
                      className="img-fluid"
                      alt="image1"
                      src={twoImages.image1}
                      loading="lazy"
                      style={{ maxHeight: "300px", objectFit: "cover" }}
                    />
                  </a>
                  </Link>
                </div>
              )}
              {twoImages.image2 && (
                <div className="col-md-6 pt-sm-mob-5">
                  <Link to="subcategory/2">
                  <a href="#">
                    <img
                      className="img-fluid"
                      alt="image2"
                      src={twoImages.image2}
                      loading="lazy"
                      style={{ maxHeight: "300px", objectFit: "cover" }}
                    />
                  </a>
                  </Link>
                </div>
              )}
            </div>
          </div>
        </section>
        {/* END TWO IMAGES */}
        {/* START SIX IMAGES */}
        <section className="mt-5">
          <div className="container-fluid">
            <div className="row">
              {gallery.map((elem, i) => (
                <div className="col-md-4 col-6 mt-3 text-center" key={i}>
                  <a href={elem.link} target="_blank" rel="noreferrer">
                    <img
                      className="img-fluid"
                      alt={`Gallery ${i}`}
                      src={elem.image}
                      loading="lazy"
                      style={{ maxHeight: "300px", objectFit: "cover" }}
                    />
                    <h5 style={{ marginTop: '0.7rem'}}>{elem.name}</h5>
                  </a>
                </div>
              ))}
            </div>
          </div>
        </section>
        {/* END SIX IMAGES */}
        {/* START MOST SELLING PRODUCTS */}
        <section>
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12 text-center my-5">
                <h1 className="under">OUR MOST SELLING PRODUCTS</h1>
              </div>
            </div>
            <Suspense fallback={<div>Loading Products...</div>}>
              <ProductSlider
                products={mostPopularProducts}
                isSlider={true}
                isBrand={false}
                addingToCartFunction={props.addingToCartFunction}
                mostpopularbrands={[]}
                emulateTouch={false}
              />
            </Suspense>
          </div>
        </section>
        {/* END MOST SELLING PRODUCTS */}
        {/* START BANNER */}
        <section className="mt-1 pt-5">
          <div className="container">
            {stocks.map((item, i) => (
              <div className={`row ${i === 1 ? "flex-row-reverse" : ""}`} key={i}>
                <div className="col-md-6 text-center p-lg-0 p-md-0">
                  <a href={item.link1}>
                    <img
                      src={item.image}
                      alt={`Banner ${i}-1`}
                      className="img-fluid"
                      loading="lazy"
                      style={{ maxHeight: "250px", objectFit: "cover" }}
                    />
                  </a>
                </div>
                <div className="col-md-6 text-center p-lg-0 p-md-0">
                  <a href={item.link2}>
                    <img
                      src={item.image2}
                      alt={`Banner ${i}-2`}
                      className="img-fluid"
                      loading="lazy"
                      style={{ maxHeight: "250px", objectFit: "cover" }}
                    />
                  </a>
                </div>
              </div>
            ))}
          </div>
        </section>  
        {/* END BANNER */}
        {/* START FEATURED PRODUCTS */}
        <section>
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12 text-center my-5">
                <h1 className="under">OUR FEATURED PRODUCTS</h1>
              </div>
            </div>
            <Suspense fallback={<div>Loading Featured Products...</div>}>
              <ProductSlider
                products={featuredProducts}
                isSlider={true}
                isBrand={false}
                addingToCartFunction={props.addingToCartFunction}
                mostpopularbrands={[]}
              />
            </Suspense>
          </div>
        </section>
        {/* END FEATURED PRODUCTS */}
        {/* START MOST POPULAR BRANDS */}
        <section>
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12 text-center my-5">
                <h1 className="under">OUR MOST POPULAR BRANDS</h1>
              </div>
            </div>
            <div className="row cate_row overflow-hidden">
              <div className="col-md-12">
                <Suspense fallback={<div>Loading Brands...</div>}>
                  <ProductSlider
                    isSlider={true}
                    products={mostPopularBrands}
                    isBrand={true}
                  />
                </Suspense>
              </div>
            </div>
          </div>
        </section>
        {/* END MOST POPULAR BRANDS */}
      </div>
    </ErrorBoundary>
  );
}

export default Home;
